/**
 * Official rules of the Einbuergerungstest, as set by the BAMF.
 * Every mock exam in this app is generated to match them exactly.
 */
export const EXAM_RULES = {
    /** 30 questions drawn from the federal catalogue (questions 1-300). */
    federalQuestions: 30,
    /** 3 questions drawn from the Bundesland catalogue (questions 301-310 here). */
    stateQuestions: 3,
    /** 33 questions in total. */
    totalQuestions: 33,
    /** 17 correct answers are required to pass. */
    passingScore: 17,
    /** 60 minutes of exam time. */
    durationMinutes: 60
};
/** Which catalogue a question belongs to. */
export const QuestionScope = {
    Federal: "FEDERAL",
    State: "STATE"
};
/** How a review was produced -- affects nothing in FSRS but is useful for statistics. */
export const StudyMode = {
    /** Self-graded flashcard: the learner presses Again/Hard/Good/Easy. */
    Flashcard: "FLASHCARD",
    /** Multiple choice with immediate feedback; the grade is derived from correctness + speed. */
    Quiz: "QUIZ",
    /** A question answered inside a timed mock exam. */
    Exam: "EXAM"
};
/** Which cards a study session should draw from. */
export const StudyFilter = {
    /** Due reviews first, then new cards, respecting the daily limits. */
    Mixed: "MIXED",
    /** Only cards that are due today. */
    DueOnly: "DUE_ONLY",
    /** Only cards never studied before. */
    NewOnly: "NEW_ONLY",
    /** Only starred cards. */
    Starred: "STARRED",
    /** Cards with the most lapses first -- the learner's personal problem set. */
    Difficult: "DIFFICULT",
    /** Only questions in the learner's mistake collection, most recently missed first. */
    Mistakes: "MISTAKES"
};
//# sourceMappingURL=types.js.map